import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';
const SvgIcon = createSvgIcon([
    React.createElement("circle", { key: '0', fill: '#FF6565', cx: '12', cy: '12', r: '12' }),
    React.createElement("path", { key: '1', fill: '#FFFFFF', d: 'M7.8,9C7,8.5,5.8,8.5,4.9,9c-0.4,0.3-0.7,0.7-1,1.1c-0.2,0.5-0.3,1-0.3,1.6v0.4c0,0.6,0.1,1.1,0.3,1.6\n\tc0.2,0.5,0.6,0.9,1,1.1c0.4,0.3,0.9,0.4,1.4,0.4c0.5,0,1-0.1,1.4-0.4c0.4-0.3,0.7-0.6,1-1.1c0.2-0.5,0.3-1,0.3-1.7v-0.4\n\tc0-0.6-0.1-1.2-0.3-1.7C8.5,9.7,8.2,9.3,7.8,9z M5.1,12.2v-0.4c0-0.6,0.1-1,0.4-1.4C5.7,10.1,6,10,6.4,10c0.4,0,0.7,0.1,0.9,0.4\n\tc0.2,0.3,0.4,0.8,0.4,1.4v0.4c0,0.6-0.1,1.1-0.4,1.4C7,13.9,6.8,14,6.4,14c-0.4,0-0.7-0.1-0.9-0.4C5.2,13.3,5.1,12.8,5.1,12.2z' }),
    React.createElement("polygon", { key: '2', fill: '#FFFFFF', points: '10.2,15.3 11.7,15.3 11.7,12.7 14.2,12.7 14.2,11.4 11.7,11.4 11.7,10 14.6,10 14.6,8.7 10.2,8.7 ' }),
    React.createElement("polygon", { key: '3', fill: '#FFFFFF', points: '20.4,10 20.4,8.7 16,8.7 16,15.3 17.5,15.3 17.5,12.7 20,12.7 20,11.4 17.5,11.4 17.5,10 ' }),
], 'TransportActivityOffIcon');
const TransportActivityOffIcon = function (props) {
    return (React.createElement(SvgIcon, Object.assign({ className: '', sx: (theme) => ({
            circle: {
                fill: theme.palette[props.color].main,
            },
        }) }, props)));
};
export default memo(TransportActivityOffIcon);
